import { unsupportedMark as unsupportedMarkFactory } from '../../next-schema/generated/markTypes';
export var unsupportedMark = unsupportedMarkFactory({
  toDOM: function toDOM() {
    return ['span'];
  }
});